module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_05-6523ff72e52719d4c15e19d9b85d0cbd.png";